import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=0ea989ab&scoped=true&"
import script from "./Config.js?vue&type=script&lang=js&"
export * from "./Config.js?vue&type=script&lang=js&"
import style0 from "./Config.vue?vue&type=style&index=0&id=0ea989ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea989ab",
  null
  
)

export default component.exports